<template>
  <modal name="marketing-preview-modal-component"
    transition="nice-modal-fade"
    classes="demo-modal-class"
    :max-width="600"
    :min-height="500"
    :pivot-y="0.5"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="80%"
    height="auto"
    @before-open="beforeOpen"
    @opened="opened"
    @closed="closed"
    @before-close="beforeClose">
  <div class="back-btn" @click="close()">
    <i class="now-ui-icons arrows-1_minimal-left"></i>
  </div>
  <div v-html="html"></div>
</modal>
</template>
<script>
  export default {
    name: 'MarketingPreviewModalComponent',
    data () {
      return {
        html: ''
      }
    },
    methods: {
      beforeOpen (event) {
        this.html = event.params.html
      },
      beforeClose () {
      },
      opened (e) {        
      },
      closed (e) {
      },
      close() {
        this.$modal.hide('marketing-preview-modal-component')
      },
    }
  }
</script>
<style>
  .size-modal-content {
    padding: 10px;
    font-style: 13px;
  }
  .v--modal-overlay[data-modal="size-modal"] {
    background: rgba(0, 0, 0, 0.5);
  }
  .demo-modal-class {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    z-index: 99999999;
    margin-top: 60px;
  }

  .back-btn {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 9999;
    opacity: 0.6;
    cursor: pointer;
    padding: 20px;
  }

  .back-btn:hover {
    opacity: 1;
  }
</style>